import React from 'react';
import ReactDOM from 'react-dom';
import { Provider } from 'react-redux';
import settings from '@salesforce/design-system-react/lib/components/settings';
import './index.css';
import App from './containers/App';
import * as serviceWorker from './serviceWorker';
import { store } from './store';

ReactDOM.render(
  <Provider store={store}>
    <App />
  </Provider>,
  document.getElementById('root')
);

settings.setAppElement('#modal-root');

// If you want your app to work offline and load faster, you can change
// unregister() to register() below. Note this comes with some pitfalls.
// Learn more about service workers: https://bit.ly/CRA-PWA
serviceWorker.unregister();
